import React, { Component } from 'react';
import { Menu, Dropdown, Icon } from 'antd';

const SubMenu = Menu.SubMenu;


export default class ThemeMenu extends Component {

    changeTheme(e) {

        if (!e.key || !e.key.startsWith('theme'))
            return;

        localStorage.theme = e.key;
        window.location.href = window.location.href;
    }

    render() {

        const menu = (
            <Menu onClick={this.changeTheme}>
                <SubMenu title="原色">
                    <Menu.Item key="theme00">
                        <div className='theme-icon' style={{ backgroundColor: '#1890ff' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme01">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(43, 87, 154, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme02">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(33, 115, 70, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme03">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(184, 59, 29, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme04">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(106, 56, 137, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme05">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(164, 55, 58, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme06">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(0, 114, 198, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme07">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(49, 117, 47, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme08">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(176, 81, 124, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme09">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(128, 57, 123, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme10">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(35, 100, 92, 255)' }}></div>
                    </Menu.Item>
                </SubMenu>

                <SubMenu title="浅色">
                    <Menu.Item key="theme11">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(43, 87, 154, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme12">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(33, 115, 70, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme13">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(184, 59, 29, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme14">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(106, 56, 137, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme15">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(164, 55, 58, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme16">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(0, 114, 198, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme17">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(49, 117, 47, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme18">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(176, 81, 124, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme19">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(128, 57, 123, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme20">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(35, 100, 92, 255)' }}></div>
                    </Menu.Item>
                </SubMenu>
                <SubMenu title="深色">
                    <Menu.Item key="theme21">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(43, 87, 154, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme22">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(33, 115, 70, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme23">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(184, 59, 29, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme24">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(106, 56, 137, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme25">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(164, 55, 58, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme26">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(0, 114, 198, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme27">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(49, 117, 47, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme28">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(176, 81, 124, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme29">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(128, 57, 123, 255)' }}></div>
                    </Menu.Item>
                    <Menu.Item key="theme30">
                        <div className='theme-icon' style={{ backgroundColor: 'rgba(35, 100, 92, 255)' }}></div>
                    </Menu.Item>
                </SubMenu>
            </Menu>
        );

        return (
            <Dropdown overlay={menu} trigger={['click']} className={this.props.className} >
                <a className="ant-dropdown-link header-dropdown" href="javascript:;">
                    <Icon type={this.props.icon || "coffee"} />
                    <span className='sp-left'>{this.props.title || "主题"}</span>
                    <Icon className='sp-left' type="down" />
                </a>
            </Dropdown>
        );
    }
}